import React, { useState} from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
// import { motion } from 'framer-motion';
import {images} from '../../constant'
import { AppWrap, MotionWrap } from '../../wrapper';

import './Testimonial.scss';

let testimonials=[
  {
    name:'Akshay Saini',
    channel:'Namaste Javascript',
    profile:images.Akshay,
    desc:`This is one the best channel to learn javascript concept from scrach in my point of view.Well explained how javascript run etc..Watch and keep doing practice with concept not mugup.`
  },
  {
    name:'BalaChandar',
    channel:'Dhuddu',
    profile:images.balachandar,
    desc:'Well Expained with practical coding section in tamil language.Around Ten Hour Vedio We Would Learn React Hooks Concept like UseState(),UseEffect() etc...Keep practice day by day.'
  },
  {
    name:'Kyle',
    channel:'Web Dev Simplified',
    profile:images.WDS,
    desc:'This is also one of the best channel to learn all FrontEnd an Backend oriented concept in English language.Such a amazing  explaination but little bit fast voiceOver u would reduce the playback speed it comfort to learn.'
  },
  {
    name:'Lokesh',
    channel:'JVL Code',
    profile:images.jvl,
    desc:'From the scrach to explaining Mongo DB in Tamil language with practicle coding How to connect frontEnd to Backend.How to sent data over database '
  },
  {
    name:'Varun',
    channel:'Great Stack',
    profile:images.GS,
    desc:'If you want to implement your coding with practice .Visit greatStack channel to build up your project by using HTML,CSS and Javascript from the scratch. '
  },
  {
    name:'Tutor Joes',
    channel:'Tutor Joes Stanley',
    profile:images.tutorJoe,
    desc:'This is also one of my best tutor in tamil language.If you want to become frontend and backend this is best channel for beginner.'
  },
  {
    name:'Jeeva',
    channel:'CS Code in Tamil',
    profile:images.CS,
    desc:'This channel i was learned basic git and github with best explaination.Other then also u would lean how browser work basic concept also explained.'
  },
  {
    name:'Mr.Ed',
    channel:'Dev By Ed',
    profile:images.DBY,
    desc:'Most of my favorite tutor of my point of view.You would like to learn deeply all front end based concept this channel helps to u.'
  },
  {
    name:'Akash',
    channel:'Code Evalution',
    profile:images.CE,
    desc:'React basic concept well explained in english.If u want to learn basic concept vist this channel best tutor ever. '
  },
];


const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div>
      {testimonials.length && (
        <div className='container'>
        <h1 className='head-text header'>MySelf Learning <span>RoadMap</span></h1>
          <div className="app__testimonial-item app__flex">
            <img src={(testimonials[currentIndex].profile)} alt={testimonials[currentIndex].name} />
            <div className="app__testimonial-content">
              <p className="p-text">{testimonials[currentIndex].desc}</p>
              <div>
                <h4 className="bold-text">{testimonials[currentIndex].name}</h4>
                <h5 className="p-text">{testimonials[currentIndex].channel}</h5>
              </div>
            </div>
          </div>

          <div className="app__testimonial-btns app__flex">
            <div className="app__flex" onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1)}>
              <HiChevronLeft />
            </div>

            <div className="app__flex" onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonial',
  'app__primarybg',
);